var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgArrowleft(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 4,
    height: 7,
    viewBox: "0 0 4 7",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_2673_20386)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M0.42311 3.51041L3.04586 6.14216C3.19856 6.28587 3.43209 6.28587 3.57581 6.14216C3.71952 5.99845 3.71952 5.75593 3.57581 5.61221L1.21351 3.24991L3.57581 0.887604C3.71952 0.734904 3.71952 0.501404 3.57581 0.357654C3.4321 0.213954 3.19857 0.213954 3.04586 0.357654L0.42311 2.98041C0.2794 3.13311 0.2794 3.36669 0.42311 3.51041Z",
    fill: "#F86557"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_2673_20386"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 4,
    height: 6.5,
    fill: "white",
    transform: "matrix(-1 0 0 -1 4 6.5)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgArrowleft);
export default __webpack_public_path__ + "static/media/arrow left.bc22635e6aea853c2642478113aabce8.svg";
export { ForwardRef as ReactComponent };